import React, { useEffect } from "react";
import GenericTableItem from "./GenericTableItem";
import Icon from "components/MainApp/atoms/Icon/icon";
import { isMobile } from "helpers/Mobile";

import styles from "./MainApp.organisms.GenericTable.module.scss";
import {
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import i18n from "i18n";

const GenericTable = ({ columns, items, totalItems, handleClick, handleCheckboxChange, checkSelectAll = false, showMessageNoneResult = true, customItemClass, customHeaderClass }) => {
  useEffect(() => {
    if(Array.isArray(columns)) return;
  }, [columns])

  const renderHeaderItem = (header) => {
    return (
      <div
        data-automation-id={`header-${header.name}`}
        key={`header-${header.name}`}
        className={`${styles["generic-table-header"]} ${header.pill ? styles["pill"] : ""} ${customHeaderClass || ""}`}
        style={{ display: header?.hideColumn ? 'none' : '' }}
      >
        {header.title}
        {header.checkbox && (
            <Checkbox
              checked={checkSelectAll}
              onChange={(e) => handleCheckboxChange(e)}
              color="primary"
            />
        )}
      </div>
    );
  };

  const table = (
    <React.Fragment>
      {(totalItems || totalItems === 0) &&<div className={styles["generic-table-total"]}>
         {i18n.t("total").toUpperCase()} <span>({totalItems})</span>
        {isMobile && totalItems > 0 && columns.map(c => c.checkbox).includes(true) &&
          <div>
            <FormControlLabel control={
              <Checkbox
                checked={checkSelectAll}
                onChange={(e) => handleCheckboxChange(e)}
                color="primary"
              />
            } label={i18n.t("select.all")}/>
          </div>
          }
      </div>}
      <div
        className={`${styles["generic-table-desktop"]} ${styles["generic-table"]}`}
        data-automation-id="table"
      >
        {!isMobile && (
          <div className={styles["generic-table-header-wrapper"]}>
            {Array.isArray(columns) && columns.map((header) => renderHeaderItem(header))}
            {!Array.isArray(columns) && Object.keys(columns).map((key) => renderHeaderItem(columns[key]))}

            <div className={styles["generic-table-header-button"]}></div>
          </div>
        )}
        <div className={styles["generic-table-content"]}>
          {items?.map((item) => {
            return (
              <div className={styles["generic-table-content-item"]} key={item.id}>
                <GenericTableItem
                  columns={Array.isArray(columns) ? columns : Object.keys(columns).map((key) => columns[key]) }
                  item={item}
                  handleClick={handleClick}
                  customItemClass={customItemClass}
                />
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );

  const noitems = (
    <React.Fragment>
      {
        showMessageNoneResult &&
          <div className={styles["generic-table-no-items"]}>
            <Icon name="apps" fill="#3C7AF5" width={87} height={65}></Icon>
            <h1>{i18n.t("no.results")}</h1>
          </div>
      }
    </React.Fragment>
  );

  return (
    <div className={`${styles["generic-table-container"]} ${customItemClass || ""}`}>
      {items.length > 0 ? table : noitems}
    </div>
  );
};

export default GenericTable;
